module.exports = __webpack_public_path__ + "img/bg-chat.a9feaa95.jpg";